/**
 * 服务商类型
 */

// cs账号类型
export enum AccountType {
  agency = 2,                                     // 服务商
  direct = 13,                                    // 直销服务商
  tech = 21,                                      // 技术服务商
}


// 平台类型
export enum AdPlatformType {
  adq = 1,
  mp = 2,
}

// 平台类型名称
export enum AdPlatformTypeName {
  adq = 'ADQ广告',
  mp = 'MP广告',
  cps = 'CPS商品广告',
}

// 服务商类型
export enum AgencyType {
  normal = 1, // 一代服务商
  child = 2, // 二代服务商
}

// 签框状态
export enum SignFrameStatus {
  frame = 1, // 签框
  nonFrame = 0, // 非框
}

// 用户认证类型
export enum UserVerifyType {
  frame = 0, // 签框
  svip = 1, // svip
  nonFrame = 2, // 非框
}

// 用户认证审核状态
export enum UserVerifyAuthStatus {
  PENDING = 0, // 待审核
  APPROVED = 1, // 审核通过
  REJECTED = 2, // 审核不通过
  NOTSUBMIT = 3, // 未提交
}

// 客户状态类型
export enum CustomerStatus {
  normal = 1,                                     // 有效
  pending = 2,                                    // 待审核
  denied = 3,                                     // 审核不通过
  frozen = 4,                                     // 冻结 (管理人员,用户不可操作) (实际上是封停，一直被用于冻结)
  tobe_accepted = 5,                              // 待接受
  tobe_activated = 6,                             // 待激活
  suspend= 10,                                    // 暂停
  material_prepared = 19,                         // 广告主资料准备
  deleted = 20,                                   // 删除
  temporary_frozen = 21,                          // 冻结(真正的冻结)
  unregistered = 40,                              // 未注册
  audit_init = 10001,                             // 预审核
  audit_reject = 10002,                           // 预审核拒绝
}

// 服务商类型
export interface Agency {
  account_type: AccountType;                      // cs账号类型
  ad_platform_type: AdPlatformType;               // 平台类型
  agency_name: string;                            // 服务商名称
  agency_uid: number;                             // 服务商UID
  customer_status: CustomerStatus;                // 客户状态
  established_time: string;                       //
  finance_label: string;                          // 财务标签名称
  finance_remark: string;                         // 财务标签备注
  finance_tag_id: number;                         // 财务标签ID
  is_adx: 0 | 1;                                  // 是否ADX
  is_cps: 0 | 1;                                  // 是否CPS
  is_ka: 0 | 1;                                   // 是否大客户销售系统服务商账号
  mdm_id: number;                                 // MDM ID
  mdm_name: string;                               // MDM名称
  parent_agency_uid: number;                      // 父级服务商
  registration_capital: string;                   //
  remark: string;                                 // 备注名称
  spid: string;                                   // 微信服务商SPID
}
